import React, { useState, useEffect } from 'react'
import Slider from './Slider'
import styled from 'styled-components';
import { Tabs, Button, Result, Spin, Image, Modal,Form,Input,InputNumber, message } from 'antd';
import API from '../../ApiService/ApiService';
import p1 from '../../Assets/Images/p_downlaod.png'
import p2 from '../../Assets/Images/p_search.png'
import p3 from '../../Assets/Images/p_sheet.png'
import p4 from '../../Assets/Images/p_document.png'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { productStart, productSuccess, productFailure } from '../../Store/Slice/ProductSlice';
import { WEB_URL } from '../../config';
import default_pro from '../../Assets/Images/pro.png'
import RelatedProducts from './RelatedProducts';
const Products = () => {
  const [loading, setLoading] = useState(false);
  const api = new API();
  const dispatch = useDispatch();
  const params = useParams();
  const singleProduct = useSelector((state) => state?.product?.productsingle?.data);
  const relatedProduct = useSelector((state) => state?.product?.relatedproducts?.data);
  //init render
  useEffect(() => {
    getProductData();
  }, [params]);

  const getProductData = async () => {
    setLoading(true);
    await api.getSingle(dispatch, [productStart, productSuccess, productFailure, "productsingle"], 'product/slug', params?.id, (err, res) => {
      setLoading(false);
      if (err) {
        dispatch(productFailure());
        dispatch(productSuccess({ type: "productsingle", data: {} }));
      }
    });
  };
  useEffect(() => {
    getRelatedProducts();
  }, [singleProduct, params]);

  const getRelatedProducts = async () => {
    singleProduct && await api.getAll(dispatch, [productStart, productSuccess, productFailure, "relatedproducts"], 'product/related', { id: singleProduct?._id }, (err, res) => {
      if (err) {
        dispatch(productFailure());
        dispatch(productSuccess({ type: "relatedproducts", data: [] }));
      }
    });
  }
  const items = [
    {
      key: '1',
      label: 'Description',
      children: <><div dangerouslySetInnerHTML={{
        __html: singleProduct?.description,
      }}></div></>,
    },
    {
      key: '2',
      label: 'Biochem/physiol Actions',
      children: <><div dangerouslySetInnerHTML={{
        __html: singleProduct?.biochem_physiol_actions,
      }}></div></>,
    },
    {
      key: '3',
      label: 'Components',
      children: <><div dangerouslySetInnerHTML={{
        __html: singleProduct?.components,
      }}></div></>,
    },
    {
      key: '4',
      label: 'Preparation Note',
      children: <><div dangerouslySetInnerHTML={{
        __html: singleProduct?.preparation_note,
      }}></div></>,
    },
  ];
const [isModalOpen, setIsModalOpen] = useState(false);
  const[formLoading,setFormLoading]=useState(false);
  const [form] = Form.useForm();
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async (values) => {
    setFormLoading(true);
    setIsModalOpen(false);
    form.resetFields();
    const remote_attr = 'https://www.reachemchemicals.com' + window.location.pathname;
    const replay_to = values['email'];
    const pname = values['name'];

    const body = `
    <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>
    
    <table style="padding-top:4px;margin:0em auto;width:600px"><tbody>
    <tr><td style="text-align:center;font-size:14px;padding-left:10px;color:#333;width:150px">This message was sent from: ${remote_attr}</td></tr>
    </tbody></table>
    
    <table style="background:#f5f5f5;border:2px solid #e5e5e5;border-collapse:collapse;padding-top:4px;margin:1.5em auto;width:600px"><tbody>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Name</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${values['name']}</td></tr>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Email</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${values['email']}</td></tr>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Phone</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${values['phone']}</td></tr>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Location</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${values['location']}</td></tr>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Product Name</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${singleProduct?.name}</td></tr>
    <tr><td style="border-right:2px solid #e5e5e5;border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:150px">Message</td><td style="border-bottom:2px solid #e5e5e5;text-align:left;font-size:14px;line-height:33px;padding-left:10px;color:#333;width:450px">${values['message']}</td></tr>
    </tbody></table>
    </body></html>
    `;

    const data = {
      replay_to: replay_to,
      pname: pname,
      body: encodeURIComponent(body)
    }
    
    await api.create(dispatch, ["", "", "", ""], 'mail', data, (err, res) => {
      if(res) {
        setIsModalOpen(false);
        form.resetFields();
        setFormLoading(false);
        message.success('Email Sent Successfully');
      } else {
        setIsModalOpen(false);
        setFormLoading(false);
        form.resetFields();
        message.error('Something went wrong! Please try again.');
      }
    });
    
  }

  return (
    <ProductSection>
      <Modal title="Request a Quote"  open={isModalOpen} onCancel={handleCancel} footer={null} width={480}>
        <Form
          name="request_a_quote"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          form={form}
          className='send_request_form'
        >
          <div className='col_1 g_20'>
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please input your name!',
              },
            ]}
            className='m_0 w_100_p'
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phone"
            rules={[
              {
                required: true,
                message: 'Please input your phone number!',
              },
            ]}
            className='m_0 w_100_p'
          >
            <InputNumber min={1} type='number' className='w_100_p' />
          </Form.Item>
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              {
                required: true,
                message: 'Please input your email address!',
              },
            ]}
            className='m_0 w_100_p'
          >
            <Input type='email' />
          </Form.Item>
          <Form.Item
            label="Location"
            name="location"
            rules={[
              {
                required: true,
                message: 'Please input your location!',
              },
            ]}
            className='m_0 w_100_p'
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Message"
            name="message"
            rules={[
              {
                required: true,
                message: 'Please input your message!',
              },
            ]}
            className='m_0 w_100_p'
          >
           <Input.TextArea />
          </Form.Item>
          <Button type="primary" htmlType="submit" className='w_f_c' loading={formLoading}>
              Send Request
            </Button>
          </div>

          
            
          
        </Form>
      </Modal>
      {
        singleProduct ? (
          <><Helmet>
            <title>{singleProduct?.meta_title ? singleProduct?.meta_title : singleProduct?.name ? singleProduct?.name : "Reachem Chemicals, Bespoke Chemical Products"}</title>
            <meta
              name="description"
              content={singleProduct?.meta_description ? singleProduct?.meta_description : singleProduct?.description ? singleProduct?.description : singleProduct?.short_description ? singleProduct?.short_description : singleProduct?.name ? singleProduct?.name : "Reachem Chemicals, Bespoke Chemical Products"}
            />
            <meta
              name="keywords"
              content={singleProduct?.meta_keywords ? singleProduct?.meta_keywords : singleProduct?.description ? singleProduct?.description : singleProduct?.short_description ? singleProduct?.short_description : singleProduct?.name ? singleProduct?.name : "Reachem Chemicals, Bespoke Chemical Products"}
            />
            <link rel="canonical" href={WEB_URL + window.location.pathname} />
            <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'Product',
              name: singleProduct?.name,
              url: WEB_URL + window.location.pathname,
              image: singleProduct?.image[0]?.image_path?api.apiUrl+singleProduct?.image[0]?.image_path:default_pro,
              brand: {
                '@type': 'Brand',
                name: 'Reachem Chemicals',
                'CAS Nos': singleProduct?.cas_nos,
                ...(singleProduct?.physical_properties || []).reduce((acc, item) => {
                  acc[item.key] = item.value;
                  return acc;
                }, {}),
                ...(singleProduct?.chemical_properties || []).reduce((acc, item) => {
                  acc[item.key] = item.value;
                  return acc;
                }, {})
              },
              aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: '5',
                bestRating: '5',
                worstRating: '0',
                ratingCount: '5',
              },
            })}
            </script>
            <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/", 
              "@type": "BreadcrumbList", 
              "itemListElement": [{
                "@type": "ListItem", 
                "position": 1, 
                "name": "Home",
                "item": "https://www.reachemchemicals.com/"  
              },{
                "@type": "ListItem", 
                "position": 2, 
                "name": "Our Products",
                "item": "https://www.reachemchemicals.com/our-product/products/"  
              },{
                "@type": "ListItem", 
                "position": 3, 
                "name": singleProduct?.name,
                "item": WEB_URL + window.location.pathname  
              }]
            })}
            </script>
          </Helmet>
            <section className="category_section_dynamic">
              <div className="wappear">
                <div className="category_section_dynamic_align">
                  <div className="dynamic_category_top">
                    <div className="dynamic_category_top_left">
                      <ul>
                        <li>Home</li>
                        <li><Link to="/category">Products</Link></li>
                        <li>{singleProduct?.name}</li>
                      </ul>
                    </div>

                  </div>
                  <div className="individual_product_details">
                    <div className="details_align">
                      <div className="details_left">
                        {
                          singleProduct?.image?.length > 0 ? (
                            <Slider image={singleProduct?.image} />
                          ) : (
                            <Image src={default_pro} alt="product" />
                          )
                        }

                      </div>
                      <div className="details_right">
                        <h1>{singleProduct?.name}</h1>
                        <div className="product_cas_nos">
                          <ul>
                            {
                              singleProduct?.cas_nos && <li><span>CAS Nos - </span><span>{singleProduct?.cas_nos}</span></li>
                            }
                            {
                              singleProduct?.cas_nos1 && <li><span>Colorless-liquid-fuming - </span> <span>Colourless-Liquid-Fuming</span></li>
                            }

                          </ul>
                        </div>
                        <div className="product_downlaod_section">
                          Documents -
                          <ul>
                            <li className="download_1">Download</li>
                            <li className="download_2">COO/COA</li>
                            <li className="download_3">Specification Sheet</li>
                            <li className="download_4">More Documents</li>
                          </ul>
                        </div>
                        {
                          singleProduct?.short_description && <div className="product_short_description">
                            <div dangerouslySetInnerHTML={{
                              __html: singleProduct?.short_description,
                            }}></div>

                          </div>
                        }
                        <div className='request_a_quote_btn'>
                          <Button htmlType='button' type='primary' size='large' onClick={showModal}>Request A Quote</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="specification_details">
                    <div className="specification_left">
                      <h2>Physical Properties</h2>
                      <table>
                        <tbody>
                          {
                            singleProduct?.physical_properties?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.key}</td>
                                  <td>{item?.value}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    <div className="specification_right">
                      <h2>Chemical Properties</h2>
                      <table>
                        <tbody>
                          {
                            singleProduct?.chemical_properties?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.key}</td>
                                  <td>{item?.value}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {
                    singleProduct?.description || singleProduct?.biochem_physiol_actions || singleProduct?.components || singleProduct?.preparation_note ? (
                      <div className="product_tab_section">
                        <Tabs defaultActiveKey="1" items={items} />

                      </div>
                    ) : (
                      <></>
                    )
                  }


                </div>
              </div>
            </section>
            {
              singleProduct?.safety_information?.length > 0 && <section className='product_safety_information'>
                <div className='wrapper'>
                  <h2>Safety Information</h2>
                  <div className="specification_details">
                    <div className="specification_left">
                      <table>
                        <tbody>
                          {
                            singleProduct?.safety_information?.map((item, index) => {
                              if (index % 2 === 0) {
                                return (
                                  <tr key={index}>
                                    <td>{item?.key}</td>
                                    <td>{item?.value}</td>
                                  </tr>
                                )
                              } else {
                                return null
                              }
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    <div className="specification_right">
                      <table>
                        <tbody>
                          {
                            singleProduct?.safety_information?.map((item, index) => {
                              if (index % 2 !== 0) {
                                return (
                                  <tr key={index}>
                                    <td>{item?.key}</td>
                                    <td>{item?.value}</td>
                                  </tr>
                                )
                              } else {
                                return null
                              }
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            }
            <section className='related_product'>
              <div className='wrapper'>

                <RelatedProducts relatedProduct={relatedProduct} />
              </div>
            </section>
          </>
        ) : (
          loading === true ? (
            <div className='wrapper'>
              <div className='loader'>
                <Spin size="large" />
              </div>
            </div>
          ) : (
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              extra={<Link to={WEB_URL} title='Back Home'><Button type="primary">Back Home</Button></Link>}
            />
          )

        )
      }

    </ProductSection>
  )
}

export default Products;


const ProductSection = styled.section`









a {
  text-decoration: none;
  color: inherit;
}
    margin: 30px 0 50px 0;

    .loader {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    

  .category_section_dynamic_align {
    display: flex;
    flex-direction: column;
    
  }

  .dynamic_category_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin: 0 0 40px;
  }

  .dynamic_category_top_left {
    max-width: 100%;
    display: inline-block;
    position: relative;
  }

  .dynamic_category_top_left ul {
    display: flex;
    align-items: center;
    list-style: none;
    gap: 10px 0;
    flex-wrap: wrap;
  }

  .dynamic_category_top_left ul li {
    color: #564B4B;
    font-size: 16px;
    cursor: pointer;
  }

  .dynamic_category_top_left ul li:last-child {
    color: #C94142;
  }

  .dynamic_category_top_left ul li:not(:last-child)::after {
    content: ">";
    margin: 0 12px;
    font-size: 15px;
  }

  .individual_product_details {
    width: 100%;
    display: inline-block;
    margin: 0 0 0px;
  }

  #sync1,
  #sync2 {
    overflow: hidden;
  }

  .details_align {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .details_align .details_left {
    width: 26%;
    display: inline-block;

  }

  .request_a_quote_btn {
    width: 100%;
    display: inline-block;
    margin: 0px 0 0 0;
  }

  .details_align .details_right {
    width: 69%;
    /* display: inline-block; */
  }

  .slider_main_item {
    width: 100%;
    box-shadow: 0 0 15px rgb(0 0 0 / 15%);
    border-radius: 5px;
    margin: 15px 0;
    overflow: hidden;
    position: relative;
  }

  #sync1 .swiper-slide {
    padding: 0 15px;
  }

  .slider_main_item .zoom_btn_product {
    position: absolute;
    top: 22px;
    right: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 37px;
    width: 37px;
    background: #fff;
    box-shadow: 0 0 15px rgb(0 0 0 / 20%);
    border-radius: 5px;
  }

  .slider_main_item .zoom_btn_product img {
    height: 18px;
  }

  #sync2 {
    margin: 20px 0 0 0;
    padding: 0 15px;
  }
  .slide_main {
    border:0;
  }
  .details_align .main {
    border: 1px solid #e9e9e9;
    /* box-shadow: 0 0 5px #000; */
    /* border-radius: 6px; */
  }
  #sync2 .swiper-slide {
    box-shadow: 0 0 5px rgb(0 0 0 / 20%);
    border-radius: 7px;
    margin: 5px 0;
    overflow: hidden;
  }

  .details_right {
    display: flex;
    flex-direction: column;
    gap: 35px;
  }

  .details_right h1 {
    margin: 0px 0 0px;
    font-size: 34px;
    font-family: "Helvetica";
    font-weight: 600;

  }

  .product_cas_nos {
    background: #C94142;
    padding: 13px 20px;
    border-radius: 5px;
  }

  .product_cas_nos ul {
    display: flex;
    gap: 20px 40px;
    flex-wrap: wrap;
    list-style: none;
  }

  .product_cas_nos ul li span:first-child {
    color: #fff;
    font-size: 16px;
    font-weight: 300;
  }

  .product_cas_nos ul li span:last-child {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5;
    font-family: "Helvetica";
  }

  .product_downlaod_section {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 30px;
  }

  .product_downlaod_section ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 25px;
  }

  .product_downlaod_section ul li {
    font-size: 15px;
    font-family: "Helvetica";
    font-weight: 500;
    color: #C94142;
    /* cursor: pointer; */
    position: relative;
  }

  .product_downlaod_section ul li:not(:last-child) {
    padding: 0 0 0 20px;
  }

  .product_downlaod_section ul li:last-child {
    padding: 0 20px 0 0px;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .download_1::before {
    content: "";
    background: url(${p1})no-repeat !important;
    height: 14px;
    background-size: contain;
    width: 15px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0px, -50%);
    background-position: center;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
  }

  .download_2::before {
    content: "";
    background: url(${p2})no-repeat !important;
    height: 14px;
    background-size: contain;
    width: 15px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0px, -50%);
    background-position: center;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
  }

  .download_3::before {
    content: "";
    background: url(${p3})no-repeat !important;
    height: 14px;
    background-size: contain;
    width: 15px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0px, -50%);
    background-position: center;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
  }

  .download_4::before {
    content: "";
    background: url(${p4})no-repeat !important;
    height: 10px;
    background-size: contain;
    width: 9px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0px, -50%);
    background-position: center;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
  }

  .product_short_description {
    width: 100%;
    padding: 30px 25px;
    border-radius: 5px;
    border: 1px solid rgb(0 0 0 / 15%);
  }
  .product_short_description p {
    font-size:16px;
    line-height: 1.5;
    color: #2E2C2C;
  }

  .product_short_description button {
    background: #C94142;
    padding: 7px 15px;
    border-radius: 5px;
    color: #fff;
    border: 0;
    margin: 15px 0 0 0;
  }

  .specification_details {
    margin: 30px 0 60px 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
    position: relative;
    width: 100%;
  }

  .specification_details h2 {
    color: #2E2C2C;
    font-size: 27px;
    margin: 0 0 25px;
    font-family: "Helvetica";
    font-weight: 600;
  }

  .specification_details table {
    width: 100%;
  }

  .specification_details td {
    padding: 20px 20px;
    border-radius: 5px;
  }

  .specification_details table tr:nth-child(odd) {
    background: #FFF9F9;
  }

  .product_tab_section {
    display: inline-block;
    margin: 60px 0;
    width: 100%;
  }

  .tab_section {
    display: inline-block;
    width: 100%;
    position: relative;
  }

  .ant-tabs-tab-btn {
    font-size: 18px;
    color: #bbbbbb;
  }

  .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000;
    text-shadow: 0 0 0.25px currentcolor;
}

.product_safety_information {
  display: inline-block;
  width: 100%;
  position: relative;
  margin: 60px 0;
}
.product_safety_information .specification_details {
  margin: 0;
}
.product_safety_information h2 {
  color: #2E2C2C;
    font-size: 27px;
    margin: 0 0 35px;
    font-family: "Helvetica";
    font-weight: 600;
    text-align: center;
}

@media screen and (max-width: 1200px) {
  .individual_product_details {
    margin: 0 0 40px;
  }
  .specification_details, .product_tab_section, .product_safety_information {
    margin: 40px 0;
  }
}

  @media screen and (max-width: 992px) {}

  @media screen and (max-width: 768px) {

    .dynamic_category_top {
      flex-direction: column;
      gap: 30px;
    }

   

    .details_align .details_left {
      width: 100%;
      margin: 0 0 45px;
    }

    .details_align .details_right {
      width: 100%;
    }

    .product_short_description {
      padding: 25px 20px;
    }

    .slider_main_item img {
      margin: auto;
    }

    .individual_product_details {
      margin: 0 0 40px;
    }

    .specification_details,
    .product_tab_section {
      margin: 40px 0;
    }

    .specification_details {
      grid-template-columns: repeat(1, 1fr);
    }

    .specification_details h2 {
      font-size: 24px;
    }

    .details_right h1 {
      font-size: 27px;
    }

    .tab_section .tab_head {
      display: none;
    }

    .mobile_dropdown {
      display: block;
      padding: 0 30px;
    }

    .dynamic_category_top {
      margin: 0 0 40px;
    }
  }

  @media screen and (max-width: 576px) {

    .dynamic_category_top {
      margin: 0 0 30px;
    }

    .specification_details td {
      padding: 10px;
    }

  }










`;